import { Component, inject, input, resource } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { firstValueFrom } from 'rxjs';
import { BlogPostComponent } from './blog-post/blog-post.component';
import { SharedNgxskeletonloaderModule } from '../../../services/ngxskeletonloader.module';

@Component({
    selector: 'app-blog',
    imports: [BlogPostComponent, SharedNgxskeletonloaderModule],
    host: { class: 'container block mx-auto overflow-hidden' },
    templateUrl: './blog.component.html',
})
export class BlogComponent {
    data = input.required<Blog>();
    apiService = inject(ApiService);
    blogPostsResource = resource({
        loader: () => firstValueFrom(this.apiService.getBlogPosts()),
    });
}

type Blog = {
    maxBlogPosts: number;
};
